<div class="grid grid-cols-12 gap-8 center">
    <app-stats-widget class="contents" />
    <app-probabilities class="col-span-12 mr-6 md:mr-0 "></app-probabilities>
</div>
